wbApp.controller('EfsReportImportDetailCtrl', ['$scope', 'localStorageService',
function ($scope, localStorageService) {

    $scope.uploadUrl = "restapi/rfid-card-logs/support/import-efs-report?deviceSerialNumber='ABC123'&dryRun=true";
    $scope.uploadSuccess = false;
    $scope.uploadFullSuccess = false;
    $scope.uploadError = false;

    var uploadComponent = null;

    $scope.model = {
        deviceSerialNumber: '',
        dryRun: true
    }

    if (localStorageService.isSupported) {
        $scope.model.deviceSerialNumber = localStorageService.get('lastRfidCardDeviceSerialNumber');
    }

    $scope.$watch('model', function (model) {
        $scope.uploadUrl = "restapi/rfid-card-logs/support/import-efs-report?deviceSerialNumber=" + encodeURI(model.deviceSerialNumber) + "&dryRun=" + model.dryRun;
        if (localStorageService.isSupported) {
            localStorageService.set('lastRfidCardDeviceSerialNumber', model.deviceSerialNumber);
        }
        uploadComponent.reset();
        $scope.uploadResultText = null;
        $scope.uploadSuccess = false;
        $scope.uploadFullSuccess = false;
        $scope.uploadError = false;
    }, true);

    $scope.fileUploaderOptions = {
        accept: "application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        uploadMode: "instantly",
        maxFileSize: 1024 * 1024 * 20, // 20 MB
        onContentReady: function (e) {
            uploadComponent = e.component;
        },
        onUploadError: function (e) {
            $scope.uploadResultText = JSON.parse(e.request.responseText);
            $scope.uploadSuccess = false;
            $scope.uploadFullSuccess = false;
            $scope.uploadError = true;
            uploadComponent.reset();
        },
        onUploadStarted: function (e) {
            $scope.uploadResultText = null;
            $scope.uploadSuccess = false;
            $scope.uploadFullSuccess = false;
            $scope.uploadError = false;
        },
        onUploaded: function (e) {
            $scope.uploadResultText = JSON.parse(e.request.responseText);
            $scope.uploadSuccess = true;
            $scope.uploadFullSuccess = !$scope.model.dryRun;
            $scope.uploadError = false;
        },
        bindingOptions: {
            uploadUrl: "uploadUrl",
            disabled: "form.$invalid"
        }
    };

}]);
